import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesTBStoreFeedbackXML {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if(webcontext.ConfigType.toLowerCase()=="form"){
            let request = JSON.parse(webcontext.RequestBody);
            if(localStorage.getItem("tbstore")){
                let tbstore = JSON.parse(localStorage.getItem("tbstore"));
                request["a_FK_Store_ID"]=tbstore.ID;
            }
            request["a_FK_SystemUser_ID"]=webcontext.Account.Id;
            webcontext.RequestBody = JSON.stringify(request);
        }
        return webcontext;
    }



    public ContextBeforeChangeValue(webcontext: any, ConfigName: string): any {
        return webcontext;
      }

}